<template>
  <td>
    <div class="cell text-center">
      <div style="width: 250px; display: inline-block;">
        <el-button @click="runFix()" class="short inline-block" >
          저장
        </el-button>
      </div>
    </div>
  </td>
</template>

<script>
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import dateMixins from "@/mixins/dateMixins";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import util from "@/mixins/util";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/utils/event-bus";
import boardValidator from "@/mixins/validators/boardValidator";

const { filterConfig } = boardFilterUtil;
export default {
  name: "BoardFixUpdateBtnComponent",
  mixins: [
    alertMixins,
    filterMixins,
    listMixins,
    dateMixins,
    boardFilterUtil,
    boardTemplateUtil,
    boardValidator
  ],
  components: {},
  inject: ["changeLoading"],
  provide() {
    return {
    };
  },
  props: {
    boardType: "",
    bidProps : "",
    hasFixBoard : 0,
    fixBoard : {},
  },
  data() {
    return {
      listApiParamSet: {},
      deleteFunc: "",
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      deleteErrorTypes: [],
      keyName: "",
      DeleteClass: null,
      deleteIndex: 0,
      deleteLastIndex: 0,
      parsingData : {},
      writeApiParamSet : {},
      writeFunc : {},
      writeSuccessType: 1,
      writeFailTypes: {},
      writeFailMsg: "",
      isRunning: false,
      directUrl: "",
    };
  },
  created() {

  },
  mounted() {
    this.initConfig();
    this.newDeleteClass();
    EventBus.$on('setSelectOneModalDataBtn', this.selectFixData);
  },
  beforeDestroy() {
    EventBus.$off('setSelectOneModalDataBtn')

  },
  destroyed() {},
  computed: {},
  methods: {
    initConfig() {
      let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
      this.listApiParamSet = boardFilterConfig.listApiParamSet;
      this.paginationType = boardFilterConfig.paginationType;
      this.getFunc = boardFilterConfig.getFunc;
      this.deleteFunc = boardFilterConfig.deleteFunc;
      this.deleteApiParamsSet = boardFilterConfig.deleteApiParamsSet;
      this.deleteSuccessType = boardFilterConfig.deleteSuccessType;
      this.deleteFailTypes = boardFilterConfig.deleteFailTypes;
      this.keyName = boardFilterConfig.keyName;
      this.parsingData = boardFilterConfig.parsingData;
      this.writeApiParamSet = boardFilterConfig.writeApiParamSet;
      this.writeFunc = boardFilterConfig.writeFunc;
      this.directUrl = boardFilterConfig.directUrl;
      this.setData('bid', this.bidProps);
    },
    setData(key, value) {
      this[key] = value;
    },
    newDeleteClass() {
      let deleteOptions = {
        func: this.$api.$board[this.deleteFunc],
        apiParamSet: this.deleteApiParamsSet,
        keyName: this.keyName,
        errorTypes: this.deleteErrorTypes,
        successType: this.deleteSuccessType,
        afterFunc: this.deleteAfterFunc,
      };
      this.DeleteClass = new DeleteClass(deleteOptions);
    },
    runDeleteConfirm() {
      this.createConfirm({
        content: "정말 삭제하시겠습니까?",
        confirm: () => {
          this.deleteIndex = 0;
          this.deleteLastIndex = this.selectArr.length - 1;
          this.runDelete();
        },
      });
    },
    runDelete() {
      if (this.bid === '') {
        this.errorAlert("고정할 게시글이 없습니다.");
        return false;
      }
      this.changeLoading(true);
      this.DeleteClass.runDelete(this.bid);
    },
    deleteAfterFunc() {
      if (this.deleteIndex < this.deleteLastIndex) {
        this.deleteIndex = this.deleteIndex + 1;
        this.runDelete();
      } else {
        this.changeLoading(false);
        this.createAlert({
          content: "저장이 완료되었습니다.",
          hide: () => {
            EventBus.$emit('getBoardFixData');
          },
        });
      }
    },
    selectFixData(data){
      this.setData('wid', data.wr_id);
    },
    checkValidator(dataArr) {
      this.$validate(dataArr)
    },
    runFix() {
      this.createConfirm({
        content: "변동사항에 대해서 저장하시겠습니까?",
        confirmText: "확인",
        confirm: () => {
          this.hasFixBoard === 0 ? this.runDelete() : this.runWrite();
        },
      });
    },
    async runWrite(){
      if (this.isRunning) {
        return false;
      }
      this.isRunning = true;
      let validator = await this._checkValidator();
      if (!validator) {
        this.isRunning = false;
        return false;
      }
      EventBus.$emit("apiLoading", true);
      let params = this._makeParams();

      try {
        this.$api.$board[this.writeFunc](params)
            .then((res) => res.Data.Result)
            .then((res) => {
              let type = this.returnWriteType(res.Info.type);
              if (type !== true) {
                this.errorAlert(type);
                EventBus.$emit("apiLoading", false);
                return (this.isRunning = false);
              }
              this.afterFunc();
              EventBus.$emit("apiLoading", false);
            });
      } catch (e) {
        console.log(e);
        this.isRunning = false;
        EventBus.$emit("apiLoading", false);
      }
    },
    _makeParams() {
      let params = Object.assign({}, this.writeApiParamSet);
      util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
        params[paramKey] = this[dataKey];
      });
      return params;
    },
    returnWriteType(type) {
      if (type === this.writeSuccessType) {
        return true;
      } else {
        return util.isEmpty(this.writeFailTypes[type])
            ? "저장 실패했습니다."
            : this.writeFailTypes[type];
      }
    },
    afterFunc() {
      EventBus.$emit("apiLoading", false);
      let content = '저장이 완료되었습니다.';
      this.createAlert({
        content: content,
        hide: () => {
          if (this.directType === "back") {
            this.$router.back();
            EventBus.$emit("apiLoading", false);
            return false;
          }
          if (this.directUrl === "") {
            this.writeLayouts = [];
            this.deleteFiles = [];
            EventBus.$emit("apiLoading", false);
            EventBus.$emit('getBoardFixData');
            return false;
          }
          EventBus.$emit("apiLoading", false);
          let url = this.directUrl;
          this.$router.push(url);
        },
      });
    },
    _checkValidator() {
      let validatorArr = Object.keys(this.parsingData);
      return this.$validate(validatorArr).then((success) => {
        if (!success) {
          this.errorAlert("필수데이터를 확인해주세요.");
          util.Array.each(this.writeLayouts, (layout, index, arr) => {
            this.checkValidator(validatorArr)
          });
          return success;
        }
        return success;
      });
    },
  },
  watch: {},
};
</script>

<style scoped></style>
